import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

import { findActivePatternItemId } from 'app/widgets/sidebar-menu/model/menu';
import useSidebarItemTitle from 'app/widgets/sidebar-menu/model/useSidebarItemTitle';

const SalaryCardPage = () => {
  const { t } = useTranslation('salary-card');
  const location = useLocation();

  // These routes share one header, so it shows the label of the sidebar link
  // that opened the current one (e.g. "Müddətin uzadılması"); the section title
  // is the fallback while the menu is unavailable.
  const sidebarTitle = useSidebarItemTitle(findActivePatternItemId(location.pathname));

  const isExtensionSuccess = location.pathname.includes('/extension/success');

  if (isExtensionSuccess) {
    return <Outlet />;
  }

  return (
    <Box sx={{ mr: { xs: 0, md: -2.5 } }}>
      <Typography fontSize={20} fontWeight={600}>
        {sidebarTitle ?? t('title')}
      </Typography>
      <Box mt={2.5}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default SalaryCardPage;
